<div class="alert alert-light my-2" role="alert">
  <lucide-icon [img]="icons.message"></lucide-icon>
  {{ contactNote() }}
</div>
